module.exports = __webpack_public_path__ + "img/675.899bf060.svg";